<template>
  <div id="news">
    <div style="position: relative; top: 0; left: 0;">
      <div
        :style="{
          height: `${phoneSearchHeight}px`
        }"
      />
      <Banner ref="banner" :banner-cat-id="12" class="banner" />
      <MyCould />
    </div>
    <div class="news-content">
      <el-row class="news-content-box">
        <el-col
          v-show="innerWidthType !== 'xs' && innerWidthType !== 'sm'"
          :span="4"
          class="side-bar-container"
        >
          <sideBar class="side-bar" :style="{ top: `${topHeight}px` }" />
        </el-col>
        <el-col :xs="22" :sm="22" :md="18" :lg="18" :xl="18">
          <div v-if="this.$route.query.id" class="content-container">
            <div class="info-title">{{ articleInfoDetail.title }}</div>
            <div class="info-time-source">
              <div class="info-time">
                发布时间：{{ articleInfoDetail.submit_time }}
              </div>
              <div class="info-source">
                来源：{{ articleInfoDetail.source }}
              </div>
            </div>
            <div class="info-detail" v-html="articleInfoDetail.content" />
          </div>
          <div v-else class="content-container">
            <div class="container-title">{{ title }}</div>
            <div class="content">
              <div
                v-for="(item, index) in articleData"
                :key="index"
                class="content-item"
                @click="goDetail(item)"
              >
                <div class="content-item-title">{{ item.description }}</div>
                <div class="content-item-time">{{ item.submit_time }}</div>
              </div>
            </div>
          </div>
          <el-pagination
            v-if="!this.$route.query.id && total > 10"
            class="page"
            layout="prev, pager, next"
            :page-size="searchData.limit"
            :total="total"
            :current-page.sync="searchData.page"
            @current-change="handleCurrentChange"
          />
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import API from '@/api/service'
import sideBar from '@/components/sideBar'

export default {
  name: 'News',
  components: {
    sideBar
  },
  data() {
    return {
      innerWidthType: '',
      articleData: [],
      articleInfoDetail: {},
      isShowCould: false,
      parent_id: '',
      searchData: {
        id: '',
        limit: 10,
        page: 1
      },
      showBanner: false,
      title: '',
      titleFont: {
        27: '和顺公告',
        28: '企业新闻',
        29: '行业动态',
        30: '媒体报道',
        31: '和顺檀'
      },
      topHeight: 0,
      total: 0,
      phoneSearchHeight: 0
    }
  },
  watch: {
    $route(newVal) {
      const bannerTop = document.querySelector('.banner').clientHeight
      document.body.scrollTop = bannerTop
      document.documentElement.scrollTop = bannerTop
      this.searchData = {
        id: '',
        limit: 10,
        page: 1
      }
      this.getArticleContent()
    }
  },
  mounted() {
    this.parent_id = this.$route.params.parent_id
    this.showBanner = true
    this.getArticleContent()
    this.getInnerWidthType()
    window.addEventListener('scroll', () => {
      this.setSideBarFix()
    })
    window.addEventListener('resize', () => {
      this.getInnerWidthType()
      this.setSideBarFix()
    })
  },
  destroyed() {
    window.removeEventListener('scroll', () => {
      this.setSideBarFix()
    })
    window.removeEventListener('resize', () => {
      this.getInnerWidthType()
      this.setSideBarFix()
    })
  },
  methods: {
    getInnerWidthType() {
      if (window.innerWidth >= 1920) {
        this.innerWidthType = 'xl'
      } else if (window.innerWidth >= 1200) {
        this.innerWidthType = 'lg'
      } else if (window.innerWidth >= 992) {
        this.innerWidthType = 'md'
      } else if (window.innerWidth > 768) {
        this.innerWidthType = 'sm'
      } else {
        this.innerWidthType = 'xs'
      }
    },
    setSideBarFix() {
      if (this.$refs.banner) {
        const bannerHeight = this.$refs.banner.$el.offsetHeight
        const bannerTop = this.$refs.banner.$el.offsetTop
        const scTop =
          document.documentElement.scrollTop || document.body.scrollTop
        const top = scTop + bannerTop
        const ofHeight =
          document.documentElement.offsetHeight || document.body.offsetHeight
        const clHeight =
          document.documentElement.clientHeight || document.body.clientHeight
        if (document.querySelector('#footer').clientHeight) {
          var footerBottom = document.querySelector('#footer').clientHeight
        }
        if (
          document.querySelector('.side-bar-container').clientHeight &&
          document.querySelector('.side-bar').clientHeight
        ) {
          var sideHeight =
            document.querySelector('.side-bar-container').clientHeight -
            document.querySelector('.side-bar').clientHeight
        }
        if (scTop > 200 && scTop < 500 && !this.isShowCould) {
          this.isShowCould = true
        }
        if (top >= bannerHeight + bannerTop) {
          this.topHeight = top - (bannerHeight + bannerTop)
        } else {
          this.topHeight = 0
        }

        if (
          sideHeight - this.topHeight < 0 &&
          footerBottom > ofHeight - scTop - clHeight
        ) {
          this.topHeight = sideHeight
        }
      }
    },
    getArticleContent() {
      this.searchData.id = this.$route.params.id
      this.title = this.titleFont[Number(this.searchData.id)]
      if (this.$route.query.id) {
        const parms = { id: this.$route.query.id }
        API.getArticleDate(parms).then(res => {
          this.articleInfoDetail = res.data
        })
      } else {
        API.getArticleList({ ...this.searchData }).then(res => {
          this.articleData = res.data
          this.total = res.count
        })
      }
    },
    handleCurrentChange(val) {
      this.searchData.page = val
      this.getArticleContent()
    },
    setHeight() {
      this.$parent.getHeightList()
    },
    goDetail(data) {
      this.$router.push({
        name: this.$route.name,
        params: {
          parent_id: this.$route.params.parent_id,
          id: this.$route.params.id
        },
        query: { id: data.id }
      })
    },
    setPhoneSearchHeight(data) {
      this.phoneSearchHeight = data
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/css/news/xl.scss";
@media screen and (max-width: 1920px) {
  @import "@/assets/css/news/lg.scss";
}
@media screen and (max-width: 1200px) {
  @import "@/assets/css/news/md.scss";
}
@media screen and (max-width: 992px) {
  @import "@/assets/css/news/sm.scss";
}
@media screen and (max-width: 768px) {
  @import "@/assets/css/news/xs.scss";
}
</style>



// WEBPACK FOOTER //
// src/view/news.vue